document.addEventListener('DOMContentLoaded', function () {
  initMediaComparisonSliders();
});

document.addEventListener('shopify:section:load', function () {
  initMediaComparisonSliders();
});

function initMediaComparisonSliders() {
  const sliders = document.querySelectorAll('.media-slider');

  sliders.forEach(function (slider) {
    // Prevent duplicate initialization
    if (slider.classList.contains('swiper-initialized')) {
      return;
    }

    const section = slider.closest('.media-comparison-slider');

    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(section.dataset.autoplaySpeed || 5000, 10);

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 600,
      watchOverflow: true,
      observer: true,
      observeParents: true,

      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      },

      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true
      },

      autoplay: autoplayEnabled
        ? {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false
    });
  });
}